import React from "react";
import ServicesGrid from "@/components/sections/ServicesGrid";
import CTASection from "@/components/sections/CTASection";
import { ShieldCheck, Zap, Headphones } from "lucide-react";

export default function Servicos() {
  return (
    <div data-testid="page-servicos">
      <section className="pt-32 md:pt-40 pb-16 bg-gradient-to-br from-[#1A1858] to-[#2E2A8C] text-white relative overflow-hidden">
        <div className="absolute inset-0 tech-grid opacity-30"></div>
        <div className="dc-container relative">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-dc-accent">Nossos serviços</span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-3 mb-5 max-w-3xl leading-tight">
            Soluções completas para a tecnologia da sua empresa
          </h1>
          <p className="text-base md:text-lg text-blue-100 max-w-3xl leading-relaxed">
            Da manutenção de equipamentos à arquitetura de sistemas em nuvem, oferecemos um portfólio completo para infraestrutura, suporte e desenvolvimento.
          </p>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="dc-container grid md:grid-cols-3 gap-6">
          <Highlight icon={ShieldCheck} title="Segurança garantida" desc="Backup 3-2-1, firewall, VPN e proteção contra ransomware." />
          <Highlight icon={Zap} title="Resposta ágil" desc="SLA dedicado com atendimento em até 1h para chamados críticos." />
          <Highlight icon={Headphones} title="Suporte completo" desc="Atendimento presencial e remoto com equipe certificada." />
        </div>
      </section>

      <ServicesGrid />

      <CTASection />
    </div>
  );
}

const Highlight = ({ icon: Icon, title, desc }) => (
  <div className="flex items-start gap-4 p-6 bg-[#f5f7fa] rounded-2xl border border-slate-100">
    <div className="w-12 h-12 rounded-xl bg-dc-primary text-white flex items-center justify-center flex-shrink-0">
      <Icon className="w-6 h-6" strokeWidth={1.6} />
    </div>
    <div>
      <h4 className="font-heading font-semibold text-lg text-dc-text mb-1">{title}</h4>
      <p className="text-sm text-slate-600">{desc}</p>
    </div>
  </div>
);
